import { memo } from "react";
import { Link, useLocation } from "react-router-dom";

type StatusColor = "Red" | "Yellow" | "Green";

type Props = {
  title: string;
  status: StatusColor;
  url: string;
  disabled?: boolean;
};

// extracted and reusable component for status indicators
const StatusBlock = memo(({ title, status, url, disabled }: Props) => {
  const location = useLocation();
  const activeColor = status.toLowerCase();

  // check if this status block's URL matches the current location
  const isActive = location.pathname === url;

  const content = (
    <div>
      <span>{title}</span>
      <div className="status-indicators flex ai-c">
        <div className={`red ${activeColor !== "red" ? "not-active" : ""}`} />
        <div
          className={`yellow ${activeColor !== "yellow" ? "not-active" : ""}`}
        />
        <div
          className={`green ${activeColor !== "green" ? "not-active" : ""}`}
        />
      </div>
    </div>
  );

  if (disabled) {
    return <div className="timeline-item">{content}</div>;
  }

  return (
    <Link to={url} className={`timeline-item ${isActive ? "active" : ""}`}>
      {content}
    </Link>
  );
});

StatusBlock.displayName = "StatusBlock";

export default StatusBlock;
